import { setEstabilishInternetFx } from "../stores/queue_rb/common";

// 
//  Функция создания запросов
// 
export const createRequestHandler = (API_URL: string) => {
    return async (to: string, method: "GET" | "POST", data: Object | Array<any> | null = null) => {
        
        const options = Object.assign({
            method: method,
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*"
            },
        }, method !== "GET" ? {
            body: JSON.stringify(data),
        } : {});

        try {
            const response = await fetch(API_URL + to, options);

            const responseData = await response.json();
            setEstabilishInternetFx(true);
            return responseData;
        } catch (error) {
            // console.error("Error:", error);
            setEstabilishInternetFx(false);

            return null;
        }
    };
}
